import React, { useState } from "react";
import "./formInput.css";

function FormInputWithoutValidations(props) {
  const [focused, setFocused] = useState(false);
  const {
    width,
    padding,
    height,
    label,
    errorMessage,
    required,
    onChange, 
    icon,
    bg,
    ...inputProps
  } = props;

  const handleFocus = () => {
    setFocused(true);
  };

  return (
    <div className="formInput">
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      <input
        {...inputProps}
        onChange={onChange}
        onBlur={handleFocus}
        onFocus={handleFocus}
        focused={focused.toString()}
        style={{ height, padding, width, backgroundColor: bg}}
      />
    </div>
  );
}

export default FormInputWithoutValidations;